import { components } from '@/types/api';
import { Switch } from '../ui/switch';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import { TransactionBlock } from './TransactionsBlock';

export function BankAccountActivites({
  account,
}: {
  account: components['schemas']['AccountDetailsOutput'];
}) {
  const { apiFetch } = useOpenApiClient();
  const queryClient = useQueryClient();
  const accountsActivitiesQuery = useQuery({
    queryKey: ['v1', 'accounts', account.id, 'activities'],
    queryFn: () =>
      apiFetch.GET('/accounts/{account_id}/activities', {
        params: {
          path: {
            account_id: account.id,
          },
        },
      }),
    select: (data) => data.data?.data,
  });
  const accountMutation = useMutation({
    mutationKey: ['v1', 'accounts', account?.id],
    mutationFn: async () => {
      if (account?.is_primary) {
        return;
      }
      return apiFetch.PATCH(`/accounts/{account_id}/primary`, {
        params: {
          path: { account_id: account.id },
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['v1', 'accounts'],
        refetchType: 'active',
      });
    },
  });
  return (
    <>
      <h3 className="text-foreground px-5 pt-0 pb-4 text-base leading-normal font-bold">
        Latest transactions
      </h3>
      <div className="scrollbar-hide no-scrollbar flex flex-col gap-1 overflow-y-auto rounded-[10px] bg-white py-3">
        {accountsActivitiesQuery.data?.map((transaction) => (
          <TransactionBlock transaction={transaction} key={transaction.id} />
        ))}
      </div>
      <h3 className="text-foreground px-5 pt-5 pb-4 text-base leading-normal font-bold">Details</h3>
      <div className="flex w-full items-center justify-center gap-2 rounded-xl bg-white py-6">
        <Switch
          disabled={account?.is_primary}
          id="primary-card"
          checked={account?.is_primary}
          onCheckedChange={() => accountMutation.mutate()}
          className="data-[state=checked]:bg-primary-mid"
        />
        <span className="text-foreground text-base font-normal">
          {account?.is_primary ? 'Primary Enrich account' : 'Make primary Enrich account'}
        </span>
      </div>
    </>
  );
}
